import MainShaftUnbalanceController from "@/controllers/wind/diagnostic/MainShaftUnbalanceController.js";

import {
	GET_MAIN_SHAFT_UNBALANCE_RESULT,
	GET_MAIN_SHAFT_UNBALANCE_RESULT_SUCCESS,
	GET_MAIN_SHAFT_UNBALANCE_RESULT_ERROR,
	GET_MAIN_SHAFT_UNBALANCE_CHART,
	GET_MAIN_SHAFT_UNBALANCE_CHART_SUCCESS,
	GET_MAIN_SHAFT_UNBALANCE_CHART_ERROR,
	RESET_MAIN_SHAFT_UNBALANCE_RESULT,
} from "./MainShaftUnbalanceActionTypes.js";

const actions = {
	[GET_MAIN_SHAFT_UNBALANCE_RESULT]: ({ commit }, resultSetId) => new Promise((resolve, reject) =>
	{
		commit(GET_MAIN_SHAFT_UNBALANCE_RESULT);

		MainShaftUnbalanceController.GetMainShaftUnbalanceResult(resultSetId)
			.then((response) =>
			{
				commit(GET_MAIN_SHAFT_UNBALANCE_RESULT_SUCCESS, response);
				resolve(response);
			})
			.catch((error) =>
			{
				commit(GET_MAIN_SHAFT_UNBALANCE_RESULT_ERROR, error);
				reject(error);
			});
	}),

	[RESET_MAIN_SHAFT_UNBALANCE_RESULT]: ({ commit }) =>
	{
		commit(RESET_MAIN_SHAFT_UNBALANCE_RESULT);
	},

	[GET_MAIN_SHAFT_UNBALANCE_CHART]: ({ commit }, parameters) => new Promise((resolve, reject) =>
	{
		commit(GET_MAIN_SHAFT_UNBALANCE_CHART);

		MainShaftUnbalanceController.GetMainShaftUnbalanceChartData(parameters.resultSetId)
			.then((response) =>
			{
				response.unbalanceMainShaftChartData.sort((a, b) =>
				{
					const nameA = a.name.toUpperCase();
					const nameB = b.name.toUpperCase();
					if (nameA < nameB)
					{
						return -1;
					}
					if (nameA > nameB)
					{
						return 1;
					}
					return 0;
				});

				response.isDarkMode = parameters.isDarkMode;
				commit(GET_MAIN_SHAFT_UNBALANCE_CHART_SUCCESS, response);
				resolve(response);
			})
			.catch((error) =>
			{
				commit(GET_MAIN_SHAFT_UNBALANCE_CHART_ERROR, error);
				reject(error);
			});
	}),
};

export default { actions };
